import { NgModule } from '@angular/core';
import { provideLazyLoad } from '@core/jss-utils';
import { generateNgrxServiceClient } from '@essent/ngrx-service-wrapper';
import { fehClient } from '@integration/api-client/feh';
import { CommonModule } from '@angular/common';
import { CommonUiProductsModule } from '@innogy/common-ui/products';
import {
  DefaultComponentModule,
  DefaultFormComponentModule,
} from '@innogy/core/modules/components';
import { SitecoreFormsModule } from '@innogy/sitecore-forms';
import { ContentSectionComponent } from '@core/content-section';

import { PriceInfoContainerComponent } from './components/price-info-container/price-info-container.component';
import { StoreProductOverviewComponent } from './components/store-product-overview/store-product-overview.component';
import { StoreReceiptComponent } from './components/store-receipt/store-receipt.component';
import { PriceInfoComponent } from './components/price-info/price-info.component';

export const { actions, effects } = generateNgrxServiceClient('FEH', fehClient);

@NgModule({
  imports: [
    DefaultComponentModule,
    DefaultFormComponentModule,
    CommonModule,
    CommonUiProductsModule,
    SitecoreFormsModule,
    PriceInfoComponent,
    PriceInfoContainerComponent,
    ContentSectionComponent,
    provideLazyLoad({
      StoreProductOverview: StoreProductOverviewComponent,
      StoreReceipt: StoreReceiptComponent,
    }),
  ],
  declarations: [StoreProductOverviewComponent, StoreReceiptComponent],
})
export class GenericStoreLazyModule {}
